/* eslint-disable require-jsdoc */
/* eslint-disable flowtype/no-types-missing-file-annotation */
import { AxiosStatic } from 'axios';
import moment from 'moment';

export default class AccountService {
    axios;
    constructor(axios: AxiosStatic) {
        this.axios = axios;
    }

    async getDataRecentCall(keyword?: string) {
        const res = await this.axios.get('/calling_history/owned', {
            params: {
                keyword
            }
        });

        return res.data.map(item => {
            switch (item.callType) {
            case 'inbound':
            case 'missed':
                return {
                    id: item?.caller?.id,
                    name: `${item?.caller?.firstName} ${item?.caller?.lastName}`,
                    avatar: item?.caller?.avatar,
                    email: item?.caller?.email,
                    createdDate: moment(item?.createdAt),
                    callType: item?.callType
                };
            case 'outbound':
                return {
                    id: item?.receiver?.user?.id,
                    name: `${item?.receiver?.user?.firstName} ${item?.receiver?.user?.lastName}`,
                    avatar: item?.receiver?.user?.avatar,
                    email: item?.receiver?.user?.email,
                    createdDate: moment(item?.createdAt),
                    callType: item?.callType
                };
            default:
                return item;
            }
        });
    }

    async getDataContact(keywords?: string, limit: number) {
        const listContact = await this.axios.get('/users/contacts/owned', {
            params: {
                keywords,
                limit
            }
        });
        let result = [];

        for (const name in listContact.data) {
            if (Array.isArray(listContact.data[name])) {
                result = result.concat(listContact.data[name]);
            } else {
                result.push(listContact.data[name]);
            }
        }

        return result.map(item => {
            return {
                ...item,
                name: `${item?.firstName} ${item?.lastName}`
            };
        });
    }

    async addNewContact(data) {
        await this.axios.post('/users/contacts', {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phoneNumber: data.phoneNumber
        });
    }
    async editContact(id, data) {
        await this.axios.put(`/users/contacts/${id}`, {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            phoneNumber: data.phoneNumber
        });
    }
    async removeContact(id) {
        await this.axios.delete(`/users/contacts/${id}`);
    }
}
